/* -----------------Child components--------------- */
import DocumentTitle from "components/DocumentTitle";

import { pageViewTypes } from "@constants/tracking";
import { events } from "@constants/tracking";
import SessionContainer from "@features/session/screens/Session";
import useAnalytics from "@hooks/useAnalytics";
/* -----------------Globals--------------- */
import { Stack } from "expo-router";
import { useMemo } from "react";

const SessionRoute = () => {
	const memoizedAnalytics = useMemo(() => {
		return {
			type: pageViewTypes.session,
			eventName: events.sessionViewed,
		};
	}, []);

	useAnalytics(memoizedAnalytics);

	return (
		<>
			<Stack.Screen
				options={{
					headerShown: false,
				}}
			/>
			<DocumentTitle title="Session" />
			<SessionContainer />
		</>
	);
};

export default SessionRoute;
